import navigation2024 from './2024'
import navigation2025 from './2025'

export const navigationList = {
  2024: navigation2024,
  2025: navigation2025,
}
